const PAGES = {
    Login: '/login',
    Editor: '/editor',
    Welcome: '/welcome',
};

Object.freeze(PAGES);

export default PAGES;
